import React from 'react';
import { AffiliateProfile } from '../../types/affiliate';

interface AffiliateStatsProps {
  stats: AffiliateProfile['stats'];
}

export const AffiliateStats: React.FC<AffiliateStatsProps> = ({ stats }) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
    }).format(amount);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {/* Total Signups */}
      <div className="bg-white p-6 rounded-lg shadow-sm border border-neutral-200">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-neutral-500">Total Signups</h3>
          <span className="p-2 bg-blue-50 text-blue-600 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </span>
        </div>
        <p className="text-3xl font-bold text-neutral-900">{stats.totalSignups}</p>
        <p className="text-sm text-neutral-500 mt-1">
          {stats.totalClicks > 0 
            ? `${((stats.totalSignups / stats.totalClicks) * 100).toFixed(1)}% conversion rate` 
            : '0% conversion rate'}
        </p>
      </div>

      {/* Pending Earnings */}
      <div className="bg-white p-6 rounded-lg shadow-sm border border-neutral-200">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-neutral-500">Pending Earnings</h3>
          <span className="p-2 bg-yellow-50 text-yellow-600 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </span>
        </div>
        <p className="text-3xl font-bold text-neutral-900">{formatCurrency(stats.pendingEarnings)}</p>
        <p className="text-sm text-neutral-500 mt-1">
          Next payout: {stats.nextPaymentDate ? stats.nextPaymentDate.toDate().toLocaleDateString() : 'TBD'}
        </p>
      </div>

      {/* Total Earnings */}
      <div className="bg-white p-6 rounded-lg shadow-sm border border-neutral-200">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-neutral-500">Total Earnings</h3>
          <span className="p-2 bg-green-50 text-green-600 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </span>
        </div>
        <p className="text-3xl font-bold text-neutral-900">{formatCurrency(stats.totalEarnings)}</p>
        <p className="text-sm text-neutral-500 mt-1">Lifetime earnings</p>
      </div>
    </div>
  );
};
